import styled from 'styled-components'

export const Styled = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  `,
  FieldWrapper: styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;

    @media (min-width: 768px) {
      grid-template-columns: 16.65rem 1fr;
    }
  `,
  Fields: styled.fieldset`
    border: 0;
    display: grid;
    gap: 0.5rem;
    grid-template-columns: 1fr;
    padding: 0;

    textarea {
      height: 100%;
      resize: none;
    }
  `,
  InvisibleFields: styled.fieldset`
    display: none;
  `,
}


